import CardList from "../../components/CardList";

export default function LandingPage() {
  return (
    <>
      <CardList />
    </>
  );
}
